import { useState, FC } from 'react';
import { useTranslation } from 'react-i18next';
import { css } from '@emotion/react';
import Button from '../Button';
import { colors, spacing, fontStyles, buildPageSpacing } from '../../styles';
import FeedbackTakeover from '../FeedbackTakeover';
import share from '../../utils/share';

const FeedbackFooter: FC = () => {
  const { t } = useTranslation();
  const [isFeedbackTakeoverShown, setIsFeedbackTakeoverShown] = useState(false);

  return (
    <div
      css={css`
        background-color: ${colors.fog};
        margin-top: ${spacing.regular};
        margin-left: calc(0px - ${buildPageSpacing(spacing.deci, 'LEFT')});
        margin-bottom: -${spacing.regular};
        width: calc(100% + ${buildPageSpacing(spacing.deci, 'LEFT')} + ${buildPageSpacing(spacing.deci, 'RIGHT')});
        html[data-theme='dark'] & {
          background-color: ${colors.liquorice};
          color: ${colors.sugar};
        }
      `}
    >
      <FeedbackTakeover isShown={isFeedbackTakeoverShown} onClose={() => setIsFeedbackTakeoverShown(false)} />
      <div
        css={css`
          padding: ${spacing.regular} ${buildPageSpacing(spacing.deci, 'RIGHT')} ${spacing.hecto}
            ${buildPageSpacing(spacing.deci, 'LEFT')};
        `}
      >
        <h3
          css={css`
            margin: 0;
            ${fontStyles.lion}
          `}
        >
          {t('feedback.enjoyingBloom')}
        </h3>
        {
          <p
            css={css`
              color: ${colors.silver};
              margin: ${spacing.centi} 0 ${spacing.regular} 0;
              ${fontStyles.flea}
              html[data-theme='dark'] & {
                color: ${colors.sugar};
              }
            `}
          >
            {t('feedback.shareOrImprove')}
          </p>
        }
        <div
          css={css`
            display: flex;
            justify-content: space-around;
            gap: ${spacing.deci};
          `}
        >
          <Button
            variant="secondary"
            onClick={share}
            css={css`
              flex: 1;
            `}
          >
            {t('feedback.shareApp')}
          </Button>
          <Button
            variant="secondary"
            onClick={() => setIsFeedbackTakeoverShown(true)}
            css={css`
              flex: 1;
            `}
          >
            {t('feedback.giveFeedback')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FeedbackFooter;
